import React, { useState, useEffect } from 'react';
import ResultLink from '../ResultLink';

export const ListingRowResults = props => {
  const { controller, facetFields, onFacetClick, facets } = props;
  const [state, setState] = useState(controller.state);

  useEffect(() => {
    controller.subscribe(() => {
      setState(controller.state);
    });
  }, []);

  const isFacetValueSelected = (facetId, facetValue) => {
    const facet = facets.find(
      facet => facet.controller.state.facetId === facetId
    );
    if (!facet) {
      return false;
    }
    return facet.controller.state.values.some(x => Object.values(x).includes(facetValue) && x.state === 'selected');
  };

  const formatDate = (timestamp) => {
    if (!timestamp) {
      return '';
    }

    const date = new Date(timestamp);

    return new Intl.DateTimeFormat('en-US', {
      month: 'long',
      day: '2-digit',
      year: 'numeric',
    }).format(date);
  };

  const shouldShowDate = (timestamp) => {
    if (!timestamp) {
      return false;
    }

    return true;
  }

  if (!state.results.length) {
    return <div>No results</div>;
  }

  return (
    <div>
      <ul style={{ textAlign: 'left' }}>
        {state.results.map(result => (
          <li key={result.uniqueId}>
            <div className="listing-row-result">
              <h3 className={`listing-row-result__title ${controller.state.isLoading ? 'listing-row-result__title--loading' : '' }`}>
                <ResultLink result={result}>
                  {result.raw.ssl_heading ? result.raw.ssl_heading : result.uri}
                </ResultLink>
              </h3>
              <div className={`listing-row-result__excerpt rtf ${controller.state.isLoading ? 'listing-row-result__excerpt--loading' : ''}`} dangerouslySetInnerHTML={{ __html: result.excerpt }} />
              { shouldShowDate(result.raw.ssl_resourcedate) && (
                <div className="listing-row-result__last__edit">
                  Created On: {formatDate(result.raw.ssl_resourcedate)}
                </div>
              )}
              <div className="listing-row-result__badges-row">
                {facetFields.map(field => {
                  return (
                    Object.keys(result.raw).includes(field) && (
                      <button
                        className={`listing-row-result__badge ${
                          isFacetValueSelected(field, result.raw[field])
                            ? 'listing-row-result__badge--selected'
                            : ''
                        }`}
                        key={field}
                        onClick={() => onFacetClick(field, result.raw[field])}
                        disabled={controller.state.isLoading}
                      >
                        {result.raw[field]}
                      </button>
                    )
                  );
                })}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
